import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./theme.css";
import "./index.css";
import "./scrollbar.css";

const rootElement = document.getElementById("root");

ReactDOM.render(<App />, rootElement);
